import * as React from "react";
import TextField from "@mui/material/TextField";
import AdapterDateFns from "@mui/lab/AdapterDateFns";

import { LocalizationProvider, StaticDatePicker } from "@mui/lab";
import DatePickerMUI from "@mui/lab/DatePicker";
import { inputClasses, inputLabelClasses, useTheme } from "@mui/material";
import { alpha } from "@material-ui/core";

function DatePicker({ ...props }) {
  const theme = useTheme();
  const [value, setValue] = React.useState(
    props.defaultValue ? new Date(props.defaultValue) : null,
  );
  const handleChange = (newValue) => {
    setValue(newValue);
  };
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePickerMUI
        closeOnSelect
        views={["day", "month", "year"]}
        {...props}
        onChange={handleChange}
        value={value}
        label={props.label}
        inputFormat="dd/MM/yyyy"
        renderInput={(params) => (
          <TextField
            id={props.id}
            fullWidth
            variant="standard"
            {...params}
            InputLabelProps={{
              sx: {
                // set the color of the label when not shrinked
                color: "gray",
                padding: "20px 18px",
                fontSize: 16,

                [`&.${inputLabelClasses.shrink}`]: {
                  // set the color of the label when shrinked (usually when the TextField is focused)
                  padding: "6px 24px",
                  lineHeight: 1,
                },
              },
            }}
            InputProps={{
              disableUnderline: true,
              ...params.InputProps,
              endAdornment: <div style={{marginRight: 4, color: 'red'}}>{params.InputProps.endAdornment}</div>,
              sx: {
                padding: "10px 18px",
                backgroundColor: alpha(theme.palette.primary.light, 0.05),
                boxShadow: "0px 0px 2px gray",
                borderRadius: 20,
                fontSize: 16,
                [`&.${inputClasses.focused}`]: {
                  boxShadow: `0 0 0 2px ${theme.palette.primary.main}`,
                },
              },
            }}
            sx={{
              paddingTop: 1,
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
}

export default DatePicker;
